<script setup>
import { defineProps, defineEmits } from "vue";

const emit = defineEmits(["setActiveItem", "setActiveMenu"]);
const props = defineProps({
  activeMenu: String,
  activeItem: String,
});

const setActive = (status) => {
  emit("setActiveItem", status);
  emit("setActiveMenu", "users");
};
</script>

<template>
  <li class="nav-item">
    <a class="nav-link" :class="{ active: props.activeMenu === 'users' }">
      <font-awesome-icon class="nav-icon" :icon="['fas', 'fa-sliders-h']" />
      <p>
        Users
        <font-awesome-icon class="right" :icon="['fas', 'fa-angle-left']" />
      </p>
    </a>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/users/central-users"
          class="nav-link"
          :class="{ active: props.activeItem === 'central-users' }"
          @click="setActive('central-users')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Central Users</p>
        </router-link>
      </li>
    </ul>

    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/users/course-users"
          class="nav-link"
          :class="{ active: props.activeItem === 'course-users' }"
          @click="setActive('course-users')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Course Users</p>
        </router-link>
      </li>
    </ul>
  </li>
</template>
